export const ERROR_ACTIVATED = 'ERROR_ACTIVATED';

export const activateError = status => ({
  type: ERROR_ACTIVATED,
  status
});
